var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJapaneseFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_10471",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 1H1V25H25V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_10471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8648 12.9998C24.8648 15.3464 24.1689 17.6404 22.8652 19.5916C21.5614 21.5428 19.7084 23.0636 17.5403 23.9616C15.3723 24.8596 12.9866 25.0946 10.685 24.6368C8.38344 24.179 6.2693 23.0489 4.60995 21.3896C2.9506 19.7302 1.82057 17.6161 1.36275 15.3145C0.90494 13.0129 1.13991 10.6273 2.03794 8.45923C2.93597 6.29118 4.45674 4.43812 6.40793 3.13438C8.35912 1.83064 10.6531 1.13477 12.9998 1.13477C16.1466 1.13477 19.1645 2.38482 21.3896 4.60994C23.6147 6.83506 24.8648 9.85297 24.8648 12.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 25C10.6266 25 8.30655 24.2962 6.33316 22.9776C4.35977 21.6591 2.8217 19.7849 1.91345 17.5922C1.0052 15.3995 0.767559 12.9867 1.23058 10.6589C1.6936 8.33115 2.83649 6.19295 4.51472 4.51472C6.19295 2.83649 8.33115 1.6936 10.6589 1.23058C12.9867 0.767559 15.3995 1.0052 17.5922 1.91345C19.7849 2.8217 21.6591 4.35977 22.9776 6.33316C24.2962 8.30655 25 10.6266 25 13C24.9963 16.1815 23.7308 19.2316 21.4812 21.4812C19.2316 23.7308 16.1815 24.9963 13 25ZM13 1.27101C10.6802 1.27101 8.41255 1.9589 6.48372 3.2477C4.5549 4.5365 3.05156 6.36832 2.16382 8.51151C1.27608 10.6547 1.04381 13.013 1.49637 15.2882C1.94894 17.5634 3.06602 19.6533 4.70635 21.2937C6.34668 22.934 8.43659 24.0511 10.7118 24.5036C12.987 24.9562 15.3453 24.7239 17.4885 23.8362C19.6317 22.9484 21.4635 21.4451 22.7523 19.5163C24.0411 17.5875 24.729 15.3198 24.729 13C24.7253 9.89042 23.4884 6.90925 21.2896 4.71044C19.0908 2.51163 16.1096 1.27471 13 1.27101Z",
    fill: "#C9CACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9333 12.9999C18.9333 14.1731 18.5855 15.3199 17.9337 16.2954C17.2819 17.2709 16.3555 18.0312 15.2716 18.4802C14.1878 18.9292 12.9951 19.0468 11.8444 18.818C10.6938 18.5892 9.63678 18.0243 8.80713 17.1948C7.97749 16.3653 7.41244 15.3084 7.18344 14.1578C6.95444 13.0071 7.07177 11.8144 7.5206 10.7305C7.96942 9.64654 8.72959 8.72002 9.70497 8.06808C10.6803 7.41614 11.8271 7.06807 13.0003 7.06787C13.7794 7.06774 14.5509 7.22108 15.2707 7.51913C15.9905 7.81718 16.6446 8.25411 17.1955 8.80496C17.7465 9.35581 18.1835 10.0098 18.4817 10.7296C18.7799 11.4493 18.9333 12.2208 18.9333 12.9999Z",
    fill: "#E60012"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
    stroke: "#BCD6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapaneseFlag);
export default __webpack_public_path__ + "static/media/japanese-flag.8c575d142b1fb90ab2e3b0ca7c9f87ec.svg";
export { ForwardRef as ReactComponent };